import { Button, Layout, theme, Form, Input, Spin, notification } from "antd";

import React, { useEffect, useState, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col, Select } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";

const ViewMCQ = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const [Questionnaires, setQuestionnaires] = useState([]);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const getquestionnaires = useCallback(() => {
    QuestionnairesApi.ListQuestionnaires()
      .then((response) => {
        setQuestionnaires(response.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getSingleQuestionset = useCallback(() => {
    QuestionnairesApi.SingleQuestionset(id)
      .then((response) => {
        setQuotations(response.payload?.questions);
        form.setFieldsValue({
          SetName: response?.payload?.questionSetsName,
          priority: response?.payload?.priority,
          passMark: response?.payload?.passMark,
          failMark: response?.payload?.failMark,
          questionerType: response?.payload?.totalNumberOfQuestions,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getquestionnaires();
    getSingleQuestionset();
  }, [getquestionnaires, getSingleQuestionset]);

  const [quotations, setQuotations] = useState([]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />

      <Layout>
        <TopHeader />
        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            form={form}
          >
            <>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="SetName"
                    label="Set Name"
                    className="text-lable"
                  >
                    <Input
                      placeholder="Set Name"
                      readOnly
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="priority"
                    label="Priority"
                    className="text-lable"
                  >
                    <Input
                      type="text"
                      min={0}
                      readOnly
                      placeholder="Priority"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Pass Mark"
                    name="passMark"
                    className="text-lable"
                  >
                    <Input
                      type="number"
                      min={0}
                      readOnly
                      placeholder="Pass Mark"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Fail Mark"
                    name="failMark"
                    className="text-lable"
                  >
                    <Input
                      type="number"
                      readOnly
                      min={0}
                      placeholder="Fail Mark"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="questionerType"
                    label="Questioner Type"
                    className="text-lable FormClass"
                  >
                    <Select
                      className="control-Select"
                      open={false}
                      placeholder="Select Questioner Type"
                      options={Questionnaires.map((item) => ({
                        value: item?.id,
                        label: item?.questionnaireType,
                      }))}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <div>
                    <div className="d-flex py-3 pt-4">
                      <h5>Questions</h5>
                    </div>
                    {quotations.map((quotation, quotationIndex) => (
                      <div key={quotationIndex}>
                        <Row gutter={16} className="mt-3">
                          <Col span={24}>
                            <Form.Item className="text-lable w-100">
                              <h5>Question {quotationIndex + 1}</h5>
                              <div key={quotationIndex} className="d-flex">
                                <Input
                                  readOnly
                                  value={quotation?.question}
                                  placeholder={`Question ${quotationIndex + 1}`}
                                  className="control-input"
                                />
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                        <div className="mx-4">
                          <Row gutter={16}>
                            <Col span={24}>
                              <Form.Item
                                label="Answers"
                                className="text-lable w-100 mx-2"
                              >
                                <Select
                                  name={`Answer${quotationIndex}`}
                                  mode="multiple"
                                  open={false}
                                  value={quotation?.options}
                                  className="select-multi"
                                  tokenSeparators={[","]}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} className="pt-3">
                            <Col span={9}>
                              <Form.Item
                                label="Answer Type"
                                className="text-lable w-100 mx-2"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Answers Type.",
                                  },
                                ]}
                              >
                                <Select
                                  name={`AnswersType${quotationIndex}`}
                                  className="control-Select mb-1"
                                  value={quotation?.answerType}
                                  open={false}
                                  placeholder="Select Answer Type"
                                  options={[
                                    { value: "RADIO", label: "Single Answer" },
                                    {
                                      value: "CHECKBOX",
                                      label: "Multiple Answer",
                                    },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={9}>
                              <Form.Item label="Mark" className="text-lable">
                                <Input
                                  type="number"
                                  min={0}
                                  readOnly
                                  name={`Mark${quotationIndex}`}
                                  value={quotation?.marks}
                                  placeholder="Mark"
                                  className="control-input"
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row gutter={16} className="pt-3">
                            <Col span={24}>
                              <Form.Item
                                label="Correct Answer"
                                className="text-lable w-100 mx-2"
                                rules={[
                                  {
                                    required: true,
                                    message: "Please enter Correct Answer.",
                                  },
                                ]}
                              >
                                {quotations[quotationIndex]?.answerType ==
                                "RADIO" ? (
                                  <>
                                    <Select
                                      name={`AnswersCorrect${quotationIndex}`}
                                      value={quotation?.correctAnswer}
                                      className="control-Select"
                                      mode="read-only"
                                      open={false}
                                      placeholder="Select Answer Type"
                                    >
                                      {quotations[quotationIndex]?.options && (
                                        <>
                                          {quotations[
                                            quotationIndex
                                          ]?.options.map((option, index) => (
                                            <option key={index} value={option}>
                                              {option}
                                            </option>
                                          ))}
                                        </>
                                      )}
                                    </Select>
                                  </>
                                ) : (
                                  <>
                                    {quotations[quotationIndex]?.options && (
                                      <>
                                        <Select
                                          mode="multiple"
                                          value={quotation?.correctAnswer.split(
                                            ","
                                          )}
                                          className="select-multi"
                                          open={false}
                                          options={quotations[
                                            quotationIndex
                                          ]?.options.map((item) => ({
                                            value: item,
                                            label: item,
                                          }))}
                                        />
                                      </>
                                    )}
                                  </>
                                )}
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default ViewMCQ;
